import { motion } from "framer-motion";
import { Calendar, Apple, Monitor } from "lucide-react";

const MAC_DOWNLOAD = "https://www.dropbox.com/scl/fi/zfx37co1gqhwzgcvx62n3/ClawdVoice-0.0.1.dmg?rlkey=qu5iuczq45oe3qwr50xzqdump&st=k4rgb2p7&dl=1";
const WIN_DOWNLOAD = "https://www.dropbox.com/scl/fi/cwk1759sxp65wox9bxii6/ClawdVoice-0.0.1.exe?rlkey=a060oado897b4hepk9t096s1h&st=ko4gdltx&dl=1";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-zinc-900 text-white"
    >
      {/* CTA Band */}
      <div className="border-b border-zinc-800">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <h2
              style={{ fontFamily: "Manrope, sans-serif" }}
              className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-2"
            >
              Ready to speak up?
            </h2>
            <p className="text-zinc-400 text-base">
              Download ClawdVoice and take control of your computer.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              data-testid="footer-download-mac"
              href={MAC_DOWNLOAD}
              className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-400 text-white font-semibold px-6 py-3 rounded-md transition-all active:scale-95"
            >
              <Apple size={18} />
              Mac
            </a>
            <a
              data-testid="footer-download-windows"
              href={WIN_DOWNLOAD}
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold px-6 py-3 rounded-md transition-all active:scale-95 border border-white/10"
            >
              <Monitor size={18} />
              Windows
            </a>
            <a
              data-testid="footer-calendly-btn"
              href="https://calendly.com/angaddubey10/new-meeting"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 font-medium px-6 py-3 rounded-md transition-all active:scale-95 border border-zinc-700"
            >
              <Calendar size={16} />
              Meet with Founders
            </a>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <span className="fn-key text-xs px-2 py-1 inline-flex bg-zinc-700">FN</span>
          <span
            style={{ fontFamily: "Manrope, sans-serif" }}
            className="text-lg font-bold tracking-tight text-white"
          >
            ClawdVoice
          </span>
        </div>

        {/* Links */}
        <nav className="flex items-center gap-6 flex-wrap justify-center">
          {["Privacy", "Terms", "Contact", "Support"].map((link) => (
            <a
              key={link}
              href="#"
              data-testid={`footer-link-${link.toLowerCase()}`}
              className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors"
            >
              {link}
            </a>
          ))}
        </nav>

        <p className="text-xs text-zinc-600 font-mono">
          &copy; {new Date().getFullYear()} ClawdVoice. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
